import { IPOI } from "@mapy/review-components";
import { DROPS } from "./const";
import { getIcon as poiaggGetIcon } from "~/util/providers/poiagg";

const lineCache: {[key: string]: any} = {};

export function getRedLineStyle() {
	const { Module } = window;
	/* eslint-disable */
	const lineStyle = new Module.LineStyle(
		6,                              // swroke width
		"#ff0000",                      // stroke color
		2,                              // line border width
		"#ffffff",                      // border color
		true,                           // keep line with between zooms:
										// this parameter defines how is line width threated (keepExactWidth)
										// keepExactWidth = true - pixel width of line is exactly keept also between map zooms (line has always the same width)
										// keepExactWidth = false - line width is scaled as map content on current map zoom
		Module.LineCapType.Round,       // line ends type (Butt, Round, Square)
		Module.LineJointType.Round,     // line joint style - joint between line segments (Bevel, Miter, Round)
		""
	);

	return lineStyle;
}

export function getColorLineStyle(strokeColor: string, borderColor: string) {
	const id = `${strokeColor}-${borderColor}`;

	if (!(id in lineCache)) {
		const { Module } = window;
		/* eslint-disable */
		const lineStyle = new Module.LineStyle(
			6,                              // swroke width
			strokeColor,                      // stroke color
			2,                              // line border width
			borderColor,                      // border color
			true,                           // keep line with between zooms:
											// this parameter defines how is line width threated (keepExactWidth)
											// keepExactWidth = true - pixel width of line is exactly keept also between map zooms (line has always the same width)
											// keepExactWidth = false - line width is scaled as map content on current map zoom
			Module.LineCapType.Round,       // line ends type (Butt, Round, Square)
			Module.LineJointType.Round,     // line joint style - joint between line segments (Bevel, Miter, Round)
			""
		);

		lineCache[id] = lineStyle;
	}


	return lineCache[id];
}

interface ICreateMarker {
	content: any;
	x: number;
	y: number;
	iconId: number;
	icon: string;
	data?: any;
	onClick?: () => void;
	onEnter?: () => void;
	onLeave?: () => void;
}

export function createMarker({
	content,
	x,
	y,
	iconId,
	icon,
	data = {},
	onClick = () => {},
	onEnter = () => {},
	onLeave = () => {},
}: ICreateMarker): number {
	return content.addPoint(x, y, iconId, window.Module.RequestedCallbacks.OnClickAndHover, {
		id: `${data.source || "source"}_${data.id || Math.random()}`,
		url: icon,
		poiData: data,
		click: e => {
			onClick();
		},
		enter: e => {
			onEnter();
		},
		leave: e => {
			onLeave();
		},
	});
}

interface ICreateGeometry {
	content: any;
	lineCoords: Array<number>;
	lineStyle: any;
	data?: any;
	onClick?: () => void;
	zIndex?: number;
}

export function createGeometry({
	content,
	lineCoords,
	lineStyle,
	data = {},
	onClick = () => {},
	zIndex = 0,
}: ICreateGeometry): number {
	return content.addLine(
		// line can be specified as [ lon, lat, lon, lat, lon, lat ... ] wgs array
		// simple array of doubles is alway threated as WGS coords
		lineCoords,
		// layer of map where line will be rendered, avalable values are:
		//  Map            - line is rendered on map, under all pois (include line and polygon pois) and texts
		//  OverVectorPois - line is rendered under text and point pois, vector pois (lines, polygons) are covered by this line
		//  OverAll        - line is rendered above map, pois and texts - this layer is also used for all point elements for now
		Module.ObjectLayer.OverAll,
		// render order inside layer, min value = , max value 65535, lower values are covered by lines with higher value
		zIndex,
		// style of line, can be used in multiple lines
		lineStyle,
		// requested callback is on hover for this line
		Module.RequestedCallbacks.OnClick,
		// user data send to on hover callback
		{
			testUserData : data,
			click: () => {
				onClick();
			},
		},
	);
}

interface IUpdateGeometry {
	content: any;
	lineId: number;
	lineCoords: Array<number>;
}

export function updateGeometry({ content, lineId, lineCoords }: IUpdateGeometry) {
	content.updateLineData(
		lineId,
		{
			coordType: Module.CoordSystem.Wgs,
			data: lineCoords,
		},
	);
}

interface IRemoveItem {
	content: any;
	wasm: number | Array<number>;
}

export function removeItem({
	content,
	wasm,
}: IRemoveItem) {
	content && content.remove(Array.isArray(wasm) ? wasm : [wasm]);
}

export function fixColor(color: string) {
	const lwColor = color.toLocaleLowerCase();

	// TODO - neni kompletni seznam barev
	if (lwColor === "white") {
		return "#ffffff";
	} else if (lwColor === "black") {
		return "#000000";
	} else if (lwColor === "red") {
		return "#ff0000";
	}

	if (color.length === 4 && color[0] === "#") {
		return `#${color[1]}${color[1]}${color[2]}${color[2]}${color[3]}${color[3]}`;
	}

	if (color[0] !== "#") {
		console.log(["color todo", color]);
	}

	return color;
}

// opacity 0-1
export function setOpacity(hashColor: string, opacity: number): string {
	const hexValue = (opacity / 1) * 255 >>> 0;
	const firstVal = hexValue / 16 >>> 0;
	const secondVal = hexValue - firstVal * 16;
	const map = "0123456789abcdef";

	return `${hashColor}${map[firstVal]}${map[secondVal]}`;
}

export function getGeometryHash(geometry) {
	const coords = geometry.getCreateData().coords || [];
	const options = geometry.getOptions();

	return btoa(JSON.stringify({
		coordsLen: coords.length,
		options,
	}));
}

export function getIcon(poi) {
	if ("icon" in poi && poi.icon["1"]) {
		return poi.icon["1"];
	}
	else if (poi.favicon) {
		return poi.favicon;
	}
	else {
		return poiaggGetIcon(poi.typeId || poi.poiTypeId);
	}
}

export function registerIcons(content: any) {
	// initialize map content visual definitions
	const DropLayer = 0; // normal priority drops
	const DropHighPriority = 1; // higher priority drops
	const DropHighPriority2 = 2; // higher priority drops

	// register big drop element with dynamic visual part
	content.registerPointElementVisual(
		DROPS.MEDIUM_RED_ICON.id,
		// each point element can be constructed from multiple textures
		// for example - drop shadow and colored drop itself and poi icon inside drop
		[
			// we always need to know size of texture & its hot point,
			// but the values can be scale to make some element smaller.
			// we can usese FIXED ulr for texture data, like this:
			new window.Module.PointElementPart(DropHighPriority, 50, 44, 15.5, 43.5, DROPS.MEDIUM_RED_ICON.src),

			// We also can use function which DYNAMICALLY resolve texture url for this part of point element.
			// Each instance of point element can provide its userData, which are then
			// send to resolving function. Each instance of point element then can have different visual
			// representation based on it's user data. (for example poi icon inside drop)
			new window.Module.PointElementPart(
				DropHighPriority, // layer for this point element part
				20, 20, 10, 38,
				// function to resolve final texture url. It is called for every instane of point element.
				// function must not be async, and must returns string url
				// empty url means hiding this part of point element
				(elementId, userData) => {
					//console.log(elementId + '  ' + userData);

					// as example we simply take url from provided object if any
					if (userData) {
						return userData.url;
					}

					// else returns empty url which hide this part of point element at all
					return '';
				}
			)
		]
	);

	content.registerPointElementVisual(
		DROPS.LARGE_RED_ICON.id,
		[
			new window.Module.PointElementPart(DropHighPriority2, 75, 66, 23.5, 65.5, DROPS.LARGE_RED_ICON.src),
			new window.Module.PointElementPart(
				DropHighPriority2,
				30, 30, 15, 57,
				(elementId, userData) => {
					if (userData) {
						return userData.url;
					}
					return '';
				}
			)
		]
	);

	// register big drop visual
	content.registerPointElementVisual(
		DROPS.BIG_RED.id,
		[new window.Module.PointElementPart(DropLayer, 75, 66, 23.5, 65.5, DROPS.BIG_RED.src)]
	);

	// register medium drop visual
	content.registerPointElementVisual(
		DROPS.MEDIUM_RED.id,
		[new window.Module.PointElementPart(DropLayer, 50, 44, 15.5, 43.5, DROPS.MEDIUM_RED.src)]
	);

	// register small drop visual
	content.registerPointElementVisual(
		DROPS.SMALL_RED.id,
		[new window.Module.PointElementPart(DropLayer, 21, 19, 6.5, 18.5, DROPS.SMALL_RED.src)]
	);

	content.registerPointElementVisual(
		DROPS.UNIVERSAL.id,
		// sirka, vyska, levy horni roh a dolu-doprava sirka, vyska
		[new window.Module.PointElementPart(DropLayer, 41, 44, 16.5, 43.5, DROPS.UNIVERSAL.src)]
	);

	content.registerPointElementVisual(
		DROPS.ROUTE_START.id,
		[new window.Module.PointElementPart(DropLayer, 75, 66, 23.5, 65.5, DROPS.ROUTE_START.src)]
	);

	content.registerPointElementVisual(
		DROPS.ROUTE_END.id,
		[new window.Module.PointElementPart(DropLayer, 75, 66, 23.5, 65.5, DROPS.ROUTE_END.src)]
	);

	content.registerPointElementVisual(
		DROPS.DISTANCEMETER.id,
		[new window.Module.PointElementPart(DropLayer, 16, 16, 8.5, 8.5, DROPS.DISTANCEMETER.src)]
	);
}

interface IPois {
	size: () => number;
	get: (ind: number) => any;
}

export function getPois(pois: IPois) {
	const output: Array<IPOI> = [];

	for (let ind = 0, max = pois.size(); ind < max; ind++) {
		const poiData = pois.get(ind);

		output.push({
			source: poiData.source,
			id: poiData.id,
			title: poiData.title,
			titleVars: {
				titleMain: poiData.title,
				specification: poiData.subtitle,
			},
			mark: {
				lon: poiData.contactPosWgs.x,
				lat: poiData.contactPosWgs.y,
			},
		});
	}

	return output;
}

export function getUserDataFromPoi(data: { Pois: IPois; }) {
	const pois = getPois(data.Pois);
	const selPoi = pois.length ? pois[0] : null;

	return {
		id: selPoi ? pois.map(poi => `${poi.source}_${poi.id}`).join("|") : Math.random().toString(),
		url: "",
		poiData: {
			...selPoi || {},
		},
		click: () => {},
		enter: () => {},
		leave: () => {},
	};
}

export function getUserDataFromMapElement(data: { Pois: IPois; UserData: any; }) {
	const poiData = data.UserData;

	return {
		id: `${poiData.source}_${poiData.id}`,
		url: "",
		poiData: {
			...poiData,
		},
		click: poiData.click,
		enter: poiData.enter,
		leave: poiData.leave,
	};
}
